import { ContentBox, Layout } from "../style";
import { PromoBox, PromoIllustration } from "./style";
import TenantHeader from "./header";
import bgImage from "../../../assets/images/img-bg-full-apply.jpg";
import evWherePromoImage from "../../../assets/images/evwhere-promo.jpg";
import successIcon from "../../../assets/images/qr-success.png";
import { Div, EvButton, Font, Row, Span } from "../../../styles/commonStyle";
import { primaryColor, modalGreyBtnColor } from "../../../styles/theme";
import { useEffect, useState } from "react";
import { isIOS, isMacOs } from "react-device-detect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function QRTenantPayResultPage() {
  const [isVisible, setIsVisible] = useState(false);
  const evWhereAppStoreUrl = "https://itunes.apple.com/kr/app/evwhere/id1231333404";
  const evWherePlayStoreUrl = "https://play.google.com/store/apps/details?id=com.ecoevc.evwhere.evwhere";
  const { tenantCode, qrcode } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  // index.tsx가 결제 성공 시에만 state.Payment=true를 실어서 이 페이지로 보낸다 - 북마크/공유/주소창
  // 직접입력처럼 이 state 없이 들어오면 결제 페이지로 돌려보낸다(뒤로/앞으로가기·새로고침은 같은
  // history 항목이라 state가 유지되므로 영향 없음)
  const state = location.state as { Payment?: boolean } | null;
  const hasPaid = state?.Payment === true;

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!hasPaid) {
      navigate(`/QRtenant/${tenantCode}/${qrcode}`, { replace: true });
    }
  }, []);

  const redirectToEvWhereStore = () => {
    if (isIOS || isMacOs) {
      window.open(evWhereAppStoreUrl, "_blank");
    } else {
      window.open(evWherePlayStoreUrl, "_blank");
    }
  };

  if (!hasPaid) {
    return null;
  }

  return (
    <Div>
      <TenantHeader />
      <Layout image={bgImage} paddingTop="0.5rem">
        <ContentBox paddingLeft="1.5rem" paddingRight="1.5rem">
          <Row
            className="justify-center w-full"
            style={{
              marginBottom: "1.5rem",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(20px)",
              transition: "all 0.6s ease-out",
            }}
          >
            <img src={successIcon} alt="success" />
          </Row>
          <Font
            fontSize="1.25rem"
            fontWeight="700"
            className="text-center w-full"
            style={{
              marginBottom: "0.5rem",
              color: "#2c3e50",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(20px)",
              transition: "all 0.6s ease-out 0.1s",
            }}
          >
            QR 인증이 완료되었습니다
          </Font>
          <Div
            className="w-full text-center"
            style={{
              marginBottom: "2rem",
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(20px)",
              transition: "all 0.6s ease-out 0.2s",
            }}
          >
            <Font color={modalGreyBtnColor} fontSize="1rem" fontWeight="500" className="text-center w-full">
              <Span color={primaryColor} fontWeight="600">충전기의 안내</Span>에 따라 충전을 시작해주세요.
            </Font>
          </Div>
          <PromoBox
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(30px)",
              transition: "all 0.8s ease-out 0.3s",
            }}
          >
            <PromoIllustration src={evWherePromoImage} alt="evWhere" />
            <Font fontSize="1rem" fontWeight="600" className="text-center">
              evWhere 앱으로 할인된 요금으로 더 편하게 충전하세요
            </Font>
            <Font fontSize="0.8rem" color={modalGreyBtnColor} fontWeight="500" className="text-center mt-[0.375rem] mb-[1rem]">
              회원 가입, 충전이력 조회, 간편결제까지 한 번에
            </Font>
            <EvButton
              width="100%"
              color="#ffffff"
              hoverColor="#ffffff"
              bgColor={primaryColor}
              type="button"
              onClick={redirectToEvWhereStore}
            >
              <FontAwesomeIcon icon={faDownload} style={{ marginRight: "0.5rem" }} />
              evWhere 다운로드하기
            </EvButton>
          </PromoBox>
        </ContentBox>
      </Layout>
    </Div>
  );
}

export default QRTenantPayResultPage;
